import { useState, useEffect } from 'react';

/**
 * useOnlineStatus
 * Returns { isOnline, justCameOnline }.
 * justCameOnline is true for one render cycle after going from offline → online,
 * useful for triggering queued-message flushes.
 */
export function useOnlineStatus() {
  const [isOnline, setIsOnline]           = useState(navigator.onLine);
  const [justCameOnline, setJustCameOnline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setJustCameOnline(true);
      // Reset the flag after one tick
      setTimeout(() => setJustCameOnline(false), 0);
    };
    const handleOffline = () => {
      setIsOnline(false);
      setJustCameOnline(false);
    };

    window.addEventListener('online',  handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online',  handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return { isOnline, justCameOnline };
}
